export default {
  talk_to_us: 'Porozmawiaj z nami:',
  send_us_email: 'Wyślij nam e-mail:',
  visit_website: 'Odwiedź naszą stronę:',
  join_our_community: 'Dołącz do naszej społeczności po ekskluzywne oferty i nowości!',
};
